var input_types = {};

module.exports = {
	getInputByType: function(type){
		if(!input_types.hasOwnProperty(type)){
			type = 'text';
		}
		return input_types[type];
	},
	setInputType: function(type, input){
		input_types[type] = input;
		return input_types[type];
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/react-loose-forms/InputTypes.js
// module id = 140
// module chunks = 0 1 2 3 4